/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Go_To_Last_PageInputs */

const en_table_go_to_last_page = /** @type {(inputs: Table_Go_To_Last_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to last page`)
};

const es_table_go_to_last_page = /** @type {(inputs: Table_Go_To_Last_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la ultima pagina`)
};

/**
* | output |
* | --- |
* | "Go to last page" |
*
* @param {Table_Go_To_Last_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_go_to_last_page = /** @type {((inputs?: Table_Go_To_Last_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Go_To_Last_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_go_to_last_page(inputs)
	return es_table_go_to_last_page(inputs)
});